import { createFileRoute } from "@tanstack/react-router";
import { loadLegacyContent, LegacyContent, legacyHead } from "@/lib/legacy-content";

export const Route = createFileRoute("/ent-surgeries/$slug")({
  loader: ({ params }) => loadLegacyContent(`ent-surgeries/${params.slug}`),
  head: ({ loaderData, params }) =>
    loaderData
      ? legacyHead(`/ent-surgeries/${params.slug}`, loaderData)
      : { meta: [{ title: "ENT Surgery — Healic" }] },
  component: () => <LegacyContent payload={Route.useLoaderData()} />,
});
